module.exports = __webpack_public_path__ + "static/media/cash_instructions.ab87f5fe.svg";